(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cosmic-timeline"] && !Shopify.designMode) return;
  try {
    
  /* Cosmic Timeline — scroll progress: the accent line fills as the section
     scrolls through the viewport and each numbered dot lights up in turn.
     Runs on all screen sizes. */
  (function () {
    function setup(root) {
      if (root.dataset.tlInit === 'true') return;
      var list = root.querySelector('.cosmic-tl__list');
      if (!list) return;
      var nodes = list.querySelectorAll('.cosmic-tl__node');
      if (!nodes.length) return;
      root.dataset.tlInit = 'true';

      var ticking = false;

      function update() {
        ticking = false;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var listRect = list.getBoundingClientRect();
        var cap = nodes[nodes.length - 1].offsetTop + 16;   // fill span: first dot → last dot
        // Scrub the fill across the section's OWN height: it starts filling when the
        // timeline enters (~top at 80% of the viewport) and completes as you scroll
        // it fully up. So the bar + numbers fill in step with how far you've scrolled
        // THROUGH the section — not all at once when it appears.
        var scrolled = (vh * 0.8) - listRect.top;
        var frac = scrolled / (list.offsetHeight || 1);
        frac = frac < 0 ? 0 : (frac > 1 ? 1 : frac);
        var fill = frac * cap;
        list.style.setProperty('--tl-progress', fill.toFixed(1) + 'px');
        for (var i = 0; i < nodes.length; i++) {
          nodes[i].classList.toggle('is-tl-active', fill >= nodes[i].offsetTop + 12);
        }
      }

      function onScroll() {
        if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      // Re-measure after web fonts/images settle so offsets are accurate.
      window.addEventListener('load', onScroll);
      update();
    }

    function init(scope) {
      var roots = (scope || document).querySelectorAll('.cosmic-tl');
      Array.prototype.forEach.call(roots, setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class LmLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lm-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        tooltip.classList.remove('show')
        tooltip.classList.add('hiding')
        setTimeout(() => {
          tooltip.classList.remove('hiding')
        }, 200);
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', LmLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services-accordion"] && !Shopify.designMode) return;
  try {
    
  class ServicesAccordion extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.singleOpen = this.hasAttribute('data-single-open');
      this.groups = Array.from(this.querySelectorAll('[data-acc-group]'));
      this.groups.forEach((group) => {
        const trigger = group.querySelector('[data-acc-trigger]');
        const panel = group.querySelector('[data-acc-panel]');
        if (!trigger || !panel) return;
        trigger.addEventListener('click', () => this.toggle(group, trigger, panel));
      });
    }

    toggle(group, trigger, panel) {
      const willOpen = !group.classList.contains('is-open');
      if (willOpen && this.singleOpen) this.closeAll();
      group.classList.toggle('is-open', willOpen);
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      panel.hidden = !willOpen;
    }

    closeAll() {
      this.groups.forEach((group) => {
        const trigger = group.querySelector('[data-acc-trigger]');
        const panel = group.querySelector('[data-acc-panel]');
        group.classList.remove('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
      });
    }
  }

  if (!customElements.get('services-accordion')) {
    customElements.define('services-accordion', ServicesAccordion);
  }

  } catch(e) { console.error(e); }
})();
})();
